import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'

import * as InfoboothsActions from './infobooths.actions'
import { InfoboothsEntity } from './infobooths.models'
import { formatForQuillEditor } from 'libs/gb-dashboard/shared/ui/src/lib/gb-quill-editor/gb-quill-editor-formatter'

export const INFOBOOTHS_FEATURE_KEY = 'infobooths'

export interface InfoboothsState extends EntityState<InfoboothsEntity> {
  selectedId?: string | number
  loaded: boolean
  editCreateLoaded: boolean
}

export interface InfoboothsPartialState {
  readonly [INFOBOOTHS_FEATURE_KEY]: InfoboothsState
}

export const infoboothsAdapter: EntityAdapter<InfoboothsEntity> = createEntityAdapter<InfoboothsEntity>({
  selectId: (infobooth: InfoboothsEntity) => infobooth.uuid,
})

export const initialInfoboothsState: InfoboothsState = infoboothsAdapter.getInitialState({
  editCreateLoaded: true,
  loaded: true,
})

const reducer = createReducer(
  initialInfoboothsState,
  on(InfoboothsActions.loadInfobooths, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(InfoboothsActions.loadInfoboothsSuccess, (state, { infobooths }) =>
    infoboothsAdapter.setAll(getFormattedInfobooths(infobooths), { ...state, loaded: true }),
  ),
  on(InfoboothsActions.selectInfobooth, (state, { uuid }) => ({
    ...state,
    selectedId: uuid,
  })),
  on(InfoboothsActions.updateSelectedInfobooth, (state) => ({ ...state, editCreateLoaded: false })),
  on(InfoboothsActions.updateSelectedInfoboothFailure, (state) => ({ ...state, editCreateLoaded: true })),
  on(InfoboothsActions.updateSelectedInfoboothSuccess, (state, action) =>
    infoboothsAdapter.updateOne(action.update, { ...state, editCreateLoaded: true }),
  ),
  on(InfoboothsActions.createInfobooth, (state) => ({ ...state, editCreateLoaded: false })),
  on(InfoboothsActions.createInfoboothFailure, (state) => ({ ...state, editCreateLoaded: true })),
  on(InfoboothsActions.createInfoboothSuccess, (state, action) =>
    infoboothsAdapter.addOne(action.infobooth, { ...state, editCreateLoaded: true }),
  ),

  on(InfoboothsActions.deleteInfoboothSuccess, (state, action) => infoboothsAdapter.removeOne(action.uuid, state)),
  on(InfoboothsActions.clearSelectedInfobooth, (state, action) => ({
    ...state,
    selectedId: initialInfoboothsState.selectedId,
  })),
  on(InfoboothsActions.clearInfobooths, (state) => ({ ...initialInfoboothsState })),
)

export function infoboothsReducer(state: InfoboothsState | undefined, action: Action) {
  return reducer(state, action)
}

export const getFormattedInfobooths = (infobooths: InfoboothsEntity[]) => {
  return infobooths.map((infobooth) => ({ ...infobooth, content: formatForQuillEditor(infobooth.content) }))
}
